export const DRAWER_WIDTH = 275; // px
export const MINI_DRAWER_WIDTH = 90; // px
